import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Country from './components/Country';
import FormHeader from './components/FormHeader';
import FormTextField from './components/FormTextField';
import { handleFieldChange } from './helpers/HandleFieldChange';
import '../styles/OnlineForm.css'
import FormFoot from './components/FormFoot';

const OnlineFormPage2 = ({ language, formData, setFormData, onNextPage, onPrevPage }) => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    let formErrors = {};

    formErrors = handleError(formData);
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      onNextPage();
    }
  };

  return (
    <>
    <FormHeader 
      language={language}
    />
    <form className='mainFormContainer' onSubmit={handleSubmit}>
    <h3 style={{fontWeight: 'lighter'}}>{t('form.optionalDataWording')}</h3>
      <label className='formLabel'>
        {t('form.country')}
        <Country 
            language={language}
            value={formData.country} 
            onChange={(value) => handleFieldChange(formData, setFormData, 'country', value)} 
            error={errors.country}
        />
      </label>
      <br />
      <FormTextField
        label={t('form.identityDocument')}
        name="identityDocument"
        value={formData.identityDocument}
        onChange={(value) => handleFieldChange(formData, setFormData, 'identityDocument', value)}
        error={errors.identityDocument}
      />
      <br />
      <FormTextField
        label={t('form.healthServiceProvider')}
        name="healthServiceProvider"
        value={formData.healthServiceProvider}
        onChange={(value) => handleFieldChange(formData, setFormData, 'healthServiceProvider', value)}
        error={errors.healthServiceProvider}
      />
      <br />
      <FormTextField
        label={t('form.emergencyMedicalService')}
        name="emergencyMedicalService"
        value={formData.emergencyMedicalService}
        onChange={(value) => handleFieldChange(formData, setFormData, 'emergencyMedicalService', value)}
        error={errors.emergencyMedicalService}
        />
      <br />
      <div className='next-back-div'>
        <button
          className='square-button-back' 
          onClick={onPrevPage}>
            <span className="button-text">{t('form.previous')}</span>
        </button>
        <button
         className='square-button-next'
         type="submit">
          <span className="button-text">{t('form.next')}</span>
        </button>
      </div>
    </form>
    <FormFoot
      language={language}
    />
    </>
  );

  function handleError(formData) {
    const formErrors = {};

    // if (formData.identityDocument && !/^[a-zA-Z0-9]+$/.test(formData.identityDocument)) {
    //   formErrors.identityDocument = t('errors.onlyLettersNumbers');
    // }
    if (!formData.country) formErrors.country = t('errors.countryError');

    if (formData.identityDocument && formData.identityDocument.length > 15) {
      formErrors.identityDocument = t('errors.max15char');
    }

    if(formData.healthServiceProvider && !/^[a-zA-Z0-9]+$/.test(formData.healthServiceProvider)) {
      formErrors.healthServiceProvider = t('errors.onlyLettersNumbers');
    }

    if (formData.healthServiceProvider && formData.healthServiceProvider.length > 10) {
      formErrors.healthServiceProvider = t('errors.max10char');
    }

    if(formData.emergencyMedicalService && !/^[a-zA-Z0-9]+$/.test(formData.emergencyMedicalService)) {
      formErrors.emergencyMedicalService = t('errors.onlyLettersNumbers');
    }

    if (formData.emergencyMedicalService && formData.emergencyMedicalService.length > 10) {
      formErrors.emergencyMedicalService = t('errors.max10char');
    }
    
    return formErrors;
  }
};

export default OnlineFormPage2;
